import { useSelector } from "react-redux";
import { FaEdit } from "react-icons/fa";
import { getshipping, shippinfidstore, shippingidremove } from "../../../../Localstorage/Store";
import { useEffect, useState } from "react";
import CreateAddress from "./CreateAddress";
import EditAddress from "./EditAddress";

const Address = ({address,onAddressChange}) => {
 const shippingid = getshipping();
 const [shipaddress, setshipaddress] = useState(false);
 const { bgColor, textColor } = useSelector((state) => state.theam);
   const [firstname_super, setfirstname_super] = useState("");
   const [lastname_super, setlastname_super] = useState("");
   const [phonenumber_super, setphonenumber_super] = useState("");
   const [emailid_super, setemailid_super] = useState("");
   const [address_type, setaddress_type] = useState("");
   const [address1_super, setaddress1_super] = useState("");
   const [address2_super, setaddress2_super] = useState("");
   const [country2_super, setcountry2_super] = useState("");
   const [state2_super, setstate2_super] = useState("");
   const [city2_super, setcity2_super] = useState("");
   const [pincode2_super, setpincode2_super] = useState("");

  const setshippadd = (id) => {
    shippinfidstore(id);
    const selectadd = address.list.filter((item) => item.id == id);
    // shippingcharges(selectadd[0].postcode);
    // handleEdit5();
  };

    const editselectaddress = async () => {
    const selectadd = address.list.filter((item) => item.id == address.default);
    setfirstname_super(selectadd[0].first_name);
    setlastname_super(selectadd[0].last_name);
    setphonenumber_super(selectadd[0].phone_number);
    setemailid_super(selectadd[0].email);
    setaddress1_super(selectadd[0].line1);
    setaddress_type(selectadd[0].address_type);
    setaddress2_super(selectadd[0].line2);
    setcountry2_super(selectadd[0].country_printable_name);
    setstate2_super(selectadd[0].state);
    setcity2_super(selectadd[0].line4);
    setpincode2_super(selectadd[0].postcode);
    setTimeout(() => {
    //   handleEdit();
    }, 600);
  };

    const selectaddress = async (address) => {
    if (shipaddress == false) {
       onAddressChange(address);
    } else {
      // setslectaddressid(address);
    }
  };



useEffect(()=>{
  shippingidremove();
},[]);





  return (
    <div
                     className="py-0"
                     style={{
                       position: "relative",
                       top: "0px",
                       background: "#ffff",
                       borderRadius: 6,
                       marginBottom: "10px",
                     }}
                   >
                     <div className="firstrow px-4 d-flex justify-content-between"
                       style={{ padding: "5px 0px", paddingLeft: "20px" }}
                     >
                       <h4
                         style={{
                           fontWeight: 700,
                         }}
                         className="titlesizes"
                       >
                         Confirm Delivery Address
                       </h4>
                     </div>
                     <div  className="firstrow px-4 pt-1 d-flex justify-content-between"
                       style={{ flexDirection: "column" }}
                     >
                       <div className="customscroll">
                       
                         {address.list.map((item, index) =>
                           address.default == item.id ? (
                             <>
                               {item.id != shippingid ? (
                                 <div
                                   class="col-lg-12"
                                   style={{
                                     marginBottom: "9px",
                                   }}
                                 >
                                   <div class="card pt-1">
                                     <div class="card-body p-0">
                                       <div
                                         class="form-check"
                                         style={{
                                           position: "relative",
                                           display: "flex",
                                           justifyContent: "flex-start",
                                         }}
                                       >
                                        
                                         <div
                                           style={{
                                             position: "absolute",
                                             top: "9px",
                                             left: "7px",
                                             width: "13px",
                                             height: "13px",
                                             border: "1px solid",
                                             borderRadius: "50%",
                                             backgroundColor: `#${bgColor}`
                                                                                     }}
                                           onChange={() => {
                                             setshippadd(item.id);
                                           }}
                                         ></div>
                                         <h5
                                           class="card-title "
                                           style={{
                                             textTransform: "capitalize",
                                             position: "relative",
                                             textAlign: "start",
                                             paddingLeft: "9px",
                                             margin: "0px",
                                             fontSize: "13px",
                                             position: "relative",
                                             top: "4px",
                                           }}
                                         >
                                           {item.first_name}&nbsp;
                                           {item.last_name}{" "}
                                           <span
                                             style={{
                                               fontSize: "10px",
                                               color: "#8d9091",
                                             }}
                                           >
                                             ({item.address_type})
                                           </span>
                                         
                                         </h5>
                                       </div>
                                       <p
                                         className="small-text"
                                         style={{
                                           textAlign: "start",
                                           paddingBottom: "6px",
                                           fontSize: "13px",
                                         }}
                                       >
                                         <span style={{ textWrap: "wrap" }}>
                                           {item.line1}
                                         </span>
                                         &nbsp;
                                         {item.line2}
                                         &nbsp;
                                         {item.country_printable_name}
                                         &nbsp;
                                         {item.state}
                                         &nbsp;
                                         {item.line4}-{item.postcode}
                                       </p>
                                       <div
                                         class="form-check"
                                         style={{
                                           position: "relative",
                                           display: "flex",
                                           justifyContent: "flex-start",
                                         }}
                                       >
                                        
 
                                         <label
                                           class="form-check-label mb-0"
                                           for="flexRadioDefault1"
                                           style={{ textAlign: "start" }}
                                         >
                                           <h5
                                             className="number"
                                             style={{
                                               paddingBottom: "4px",
                                               textAlign: "start",
                                               fontSize: "13px",
                                             }}
                                           >
                                             Mobile:{" "}
                                             <span
                                               className="number2"
                                               style={{
                                                 textTransform: "none",
                                                 fontSize: "13px",
                                               }}
                                             >
                                               {item.phone_number}
                                             </span>
                                           </h5>
                                          
                                         </label>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               ) : (
                                 ""
                               )}
                             </>
                           ) : (
                             ""
                           )
                         )}
                         {address.list.map((item, index) =>
                           address.default != item.id ? (
                             <>
                               {item.id != shippingid ? (
                                 <div
                                   class="col-lg-12"
                                   style={{
                                     marginBottom: "9px",
                                   }}
                                 >
                                   <div class="card pt-1">
                                     <div class="card-body p-0">
                                       <div
                                         class="form-check"
                                         style={{
                                           position: "relative",
                                           display: "flex",
                                           justifyContent: "flex-start",
                                         }}
                                       >
                                         <input
                                           type="radio"
                                           name="flexRadioDefault"
                                           style={{
                                             position: "absolute",
                                             top: "9px",
                                             left: "7px",
                                           }}
                                           onClick={(e) =>
                                             selectaddress(item.id)
                                           }
                                         />
                                         <h5
                                           class="card-title "
                                           style={{
                                             textTransform: "capitalize",
                                             position: "relative",
                                             textAlign: "start",
                                             paddingLeft: "9px",
                                             margin: "0px",
                                             fontSize: "13px",
                                             position: "relative",
                                             top: "4px",
                                           }}
                                         >
                                           {item.first_name}&nbsp;
                                           {item.last_name}{" "}
                                           <span
                                             style={{
                                               fontSize: "10px",
                                               color: "#8d9091",
                                             }}
                                           >
                                             ({item.address_type})
                                           </span>
                                          
                                         </h5>
                                       </div>
                                       <p
                                         className="small-text"
                                         style={{
                                           textAlign: "start",
                                           paddingBottom: "6px",
                                           fontSize: "13px",
                                         }}
                                       >
                                         <span style={{ textWrap: "balance" }}>
                                           {item.line1}
                                         </span>
                                         &nbsp;
                                         {item.line2}
                                         &nbsp;
                                         {item.country_printable_name}
                                         &nbsp;
                                         {item.state}
                                         &nbsp;
                                         {item.line4}-{item.postcode}
                                       </p>
                                       <div
                                         class="form-check"
                                         style={{
                                           position: "relative",
                                           display: "flex",
                                           justifyContent: "flex-start",
                                         }}
                                       >
                                       
 
                                         <label
                                           class="form-check-label mb-0"
                                           for="flexRadioDefault1"
                                           style={{ textAlign: "start" }}
                                         >
                                           <h5
                                             className="number"
                                             style={{
                                               paddingBottom: "4px",
                                               textAlign: "start",
                                               fontSize: "13px",
                                             }}
                                           >
                                             Mobile:{" "}
                                             <span
                                               className="number2"
                                               style={{
                                                 textTransform: "none",
                                                 fontSize: "13px",
                                               }}
                                             >
                                               {item.phone_number}
                                             </span>
                                           </h5>
                                          
                                         </label>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               ) : (
                                 ""
                               )}
                             </>
                           ) : (
                             ""
                           )
                         )}
                       </div>
                     </div>

                     <div className="firstrow px-4 pt-1 d-flex justify-content-between">
                       <span
                         style={{
                           fontWeight: 600,
                           fontSize: "12px",
                           paddingLeft: "0px",
                           alignSelf: "center",
                         }}
                       >
                       </span>
                       <span
                         style={{
                           fontWeight: 500,
                           color: "#230BB3",
                           fontSize: "12px",
                           display: "flex",
                           gap: "5px",
                         }}
                       >
                        <CreateAddress address={address} onAddressChange={onAddressChange} />
                        <EditAddress address={address} onAddressChange={onAddressChange} addressToEdit={address.list.find((item) => item.id == address.default)} />
                         {/* <button
                           style={{
                             border: "none",
                             outline: "none",
                             backgroundColor: "#fff",
                             padding: "3px 3px",
                             color: `#${bgColor}`,
                             width: "fit-content",
                             fontWeight: 600,
                           }}
                           onClick={() => {
                             editselectaddress();
                           }}
                         >
                           <FaEdit
                             style={{
                               fontSize: "10px",
                               position: "relative",
                               top: "-1px",
                               left: "2px",
                             }}
                           />{" "}
                           Edit
                         </button> */}
                       </span>
                     </div>




 


                    </div>
  )
}

export default Address